export const MESSAGE_ENVELOPE_VERSION = "1.0" as const;
